/* @flow */

import _Header from './Header';

export default _Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js